/**
 * @Author: Ygm
 * @Date: 2024-07-12 09:34:38
 * @LastEditors: Ygm
 * @LastEditTime: 2024-08-01 14:07:01
 * @Description: 根据数据变化将节点滚动到顶部
 */
const scrollToTop = {
  bind(el, binding, vnode) {
    // 获取 Antd 表格组件实例
    const tableComponent = vnode.context.$refs[binding.arg]
    if (!tableComponent) {
      console.warn(`没有找到名为 ${binding.arg} 的组件实例`)
      return
    }

    // 获取表格组件的容器元素，使用传入的参数，如果没有传入则默认使用 '.ant-table-body'
    const containerSelector = binding.value || '.ant-table-body'
    const tableContainer = tableComponent.$el && tableComponent.$el.querySelector(containerSelector)

    if (!tableContainer) {
      console.warn(`没有找到选择器为 ${containerSelector} 的容器元素`)
      return
    }

    // 监听数据变化
    vnode.context.$watch(
      () => tableComponent.dataSource,
      (newValue, oldValue) => {
        if (isDataChanged(newValue, oldValue)) {
          tableContainer.scrollTop = 0
        }
      }
    )

    // 判断数据状态
    function isDataChanged(newValue, oldValue) {
      return (
        Array.isArray(newValue) &&
        Array.isArray(oldValue) &&
        newValue.length > 0 &&
        oldValue.length > 0 &&
        newValue[0].title !== oldValue[0].title
      )
    }
  }
}

export default scrollToTop



// WEBPACK FOOTER //
// ./src/directive/scrollToTop/index.js